import { axios } from "../../../Config/axiosConfig";
import routes from "../../../API/routes";
import { Sessao, SessaoUsuario, setSessaoUsuario, limparSessao } from "../../../Utils/token";
import keycloack from "../../../keycloak";
import baseApi from "../../../API/baseApi";
const CONTA_URL = process.env.REACT_APP_CONTA_URL;
const TERMO_API_URL = process.env.REACT_APP_TERMO_API_URL;



export const setContratoAceito = async () => {
  try {
    const { status, data } = await axios.post(`${TERMO_API_URL}/verificaContratoAceito/5`);
    const contratoAceito = status === 200 && data.sucesso;
    localStorage.setItem("_20ex20", contratoAceito);
    return contratoAceito;
  } catch (error) {
    return false;
  }
};

export const isContratoAceito = async () => {
  if (JSON.parse(localStorage.getItem("_20ex20"))) {
    return true;
  }

  return await setContratoAceito();
};

export const buscarDadosCliente = async () => {
  const { pathname } = window.location;

  if (pathname === "/") {
    await baseApi.get(routes.usuario.obterDadosUsuario)
      .then(async ({ data, status }) => {
        if (status === 200) {

          const {data: { email, nome, codigoCliente, isAdmin, razaoSocialCliente : clienteRazaoSocial } } = data;

          setSessaoUsuario( { isAdmin, email, clienteRazaoSocial } )
         
          localStorage.setItem("nome", nome);
          localStorage.setItem("email", email);

          window?.clarity?.('identify', email);
          window?.clarity?.('set','Login usuário', email);
          window?.clarity?.('set', 'Código cliente', codigoCliente);
          
          if (await isContratoAceito()) {
            window.location = "/home";
          } else {
            window.location = "/contrato";
          }
        } else {
          window.location = CONTA_URL;
        }
      })
      .catch((err) => {
        console.log({err});
        window.location = CONTA_URL;
      });
  }
};

export const getToken = () => Sessao("access_token");

export const logout = () => {
  localStorage.clear();
  keycloack.logout({redirectUri: process.env.REACT_APP_CONTA_URL})
    .then(() => {
      limparSessao();
    })
    .catch(() => {
      limparSessao();
      window.location = process.env.REACT_APP_CONTA_URL;
    });
};

export const setUsuario = (usuario) => {
  localStorage.setItem("token", usuario.token);
  localStorage.setItem("email", usuario.email);
};

export const getEmailLogged = () => SessaoUsuario("email");
